export enum EStatus {
  INATIVO = 'INATIVO',
  ATIVO = 'ATIVO'
}
